<template>
    <div>
        <Counter :max="10" :min="2" @counter="getGoodInfo('counter',$event)"/>
        <DownMenu :DownData="DownMenu" @downMenu="getGoodInfo('downmenu',$event)"/>
        <Radios :Radios="Radios" @radios="getGoodInfo('radios',$event)"/>
        <p>{{totalprice}}</p>
        <p>{{$store.dispatch('updateOrder',priceAmount)}}</p>
        <p>{{ $store.state.order}}</p>
    </div>
</template>
<script>
    import Counter from './components/Counter'
    import DownMenu from './components/DownMenu'
    import Radios from './components/Radios'
    export default {
        data() {
            return {
                counter: 1,
                downmenu: 1,
                radios: 1,
                Ftotalprice: 19,
                priceAmount:{
                    counter: 0,
                    downmenu: 0,
                    radios:0,
                },
                Radios: [
                    {
                        title: "1个月",
                        value: 1
                    },
                    {
                        title: "3个月",
                        value: 3
                    },
                    {
                        title: "半年",
                        value: 6
                    },
                    {
                        title: "年费",
                        value: 12
                    }
                ],
                Counter: {
                    max: 10,
                    min: 1
                },
                DownMenu: [
                    {
                        name: "初级版",
                        value: 1
                    },
                    {
                        name: "中级版",
                        value: 2
                    },
                    {
                        name: "高级版",
                        value: 3
                    }
                ]
            }
        },
        components: {
            Counter,
            DownMenu,
            Radios
        },
        methods: {
            getGoodInfo(key,value){
                this.priceAmount[key] = value
            },

            
        },
        // created: {
        //     // this.$store.dispatch("updateOrder", this.state);
        // },
        computed: {
            totalprice() {
                // console.log(this.priceAmount)dispatch
                // this.$store.dispatch('updateOrder',this.state)
                
                return this.priceAmount.counter*5+this.Ftotalprice+this.priceAmount.downmenu*2+this.priceAmount.radios*10
            }
        }
    }
</script>
<style scoped>
    .buy-dialog-title {
        font-size: 16px;
        font-weight: bold;
    }

    .buy-dialog-btn {
        margin-top: 20px;
    }

    .buy-dialog-table {
        width: 100%;
        margin-bottom: 20px;
    }

    .buy-dialog-table td,
    .buy-dialog-table th {
        border: 1px solid #e3e3e3;
        text-align: center;
        padding: 5px 0;
    }

    .buy-dialog-table th {
        background: #4fc08d;
        color: #fff;
        border: 1px solid #4fc08d;
    }

    .button {
        background: #4fc08d;
        color: #fff;
        display: inline-block;
        padding: 10px 20px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/pages/details/car.vue